/**
 * 阴影得级联模式。
 */
export enum ShadowCascadesMode {
    /** 无级联。 */
    NoCascades,
    /** 二级级联。 */
    TwoCascades,
    /** 四级级联。 */
    FourCascades,
}